// src/private/src/pages/app/clients/components/SectionNav.jsx
import React, { memo, useCallback } from 'react';
import { Box, Chip, Stack } from '@mui/material';
import { SECTION_NAV_ITEMS } from './dashboardUtils';

/**
 * Sticky horizontal chip bar for quick-jumping to dashboard sections.
 * Scrolls the corresponding accordion into view smoothly.
 */
function SectionNav({ isStaff = false }) {
  const handleClick = useCallback((sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'auto',
        py: 0.5,
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-thumb': { bgcolor: 'divider', borderRadius: 2 },
      }}
    >
      <Stack direction="row" spacing={0.75} sx={{ minWidth: 'max-content' }}>
        {SECTION_NAV_ITEMS.filter((item) => !item.staffOnly || isStaff).map((item) => (
          <Chip
            key={item.id}
            label={item.label}
            size="small"
            variant="outlined"
            onClick={() => handleClick(item.id)}
            sx={{
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '0.75rem',
              '&:hover': { bgcolor: 'action.hover' },
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}

export default memo(SectionNav);
